/* Una hoja que sube desde abajo (en escritorio, desde la derecha). Se cierra con ✕, Esc o tocando fuera. */
import { useCallback, useLayoutEffect, useRef, type ReactNode } from 'react';
import { reducido } from '../escena/motor.ts';

interface Props {
  id: string;
  titulo: string;                      // id del h2 que la nombra
  clase?: string;                      // variante (la del mapa es más alta y ancha)
  onCerrada: () => void;
  children: (cerrar: () => void, dialogo: HTMLDialogElement | null) => ReactNode;
}

export function Hoja({ id, titulo, clase, onCerrada, children }: Props) {
  const ref = useRef<HTMLDialogElement>(null);

  useLayoutEffect(() => {
    const d = ref.current;
    if (!d || d.open) return;
    d.showModal();
    // showModal enfoca el ✕ y saldría su anillo; el foco va al contenido (el lector empieza por el título)
    d.querySelector<HTMLElement>('.hoja__dentro')?.focus({ preventScroll: true });
  }, []);

  const cerrar = useCallback(() => {
    const d = ref.current;
    if (!d?.open || d.classList.contains('cerrando')) return;
    if (reducido()) { d.close(); onCerrada(); return; }
    d.classList.add('cerrando');
    d.addEventListener('animationend', () => { d.classList.remove('cerrando'); d.close(); onCerrada(); }, { once: true });
  }, [onCerrada]);

  return (
    <dialog
      className={`hoja${clase ? ` ${clase}` : ''}`}
      id={id}
      ref={ref}
      aria-labelledby={titulo}
      onClick={e => { if (e.target === ref.current) cerrar(); }}
      onCancel={e => { e.preventDefault(); cerrar(); }}
    >
      <div className="hoja__asa" aria-hidden="true" />
      <button className="hoja__cerrar" type="button" aria-label="Cerrar" onClick={cerrar}>✕</button>
      <div className="hoja__dentro" tabIndex={-1}>
        {children(cerrar, ref.current)}
      </div>
    </dialog>
  );
}
